import * as React from 'react';
import CopyButton from './copy_button';
import { shallow, ShallowWrapper } from 'enzyme';

let wrapped: ShallowWrapper;

describe('Copy Button component', () => {
  beforeEach(() => {
    wrapped = shallow(<CopyButton content='' />);
  });

  it('shallow renders without crashing', () => {
    expect(wrapped.exists()).toBe(true);
  });
});

test.todo('add more tests');
